import { get } from "@ember/object"
import Service, { inject as service } from "@ember/service"
import { filter, forEach, remove } from "lodash-es"

interface Query {
  queryInstanceId: string
  id: string
  type: string
  invalidationCallback?: () => void
}

export default class QueryService extends Service {
  _queries: Array<Query> = []
  inFlightQueriesCount = 0

  @service socket

  @service("ember-store") store

  @service rpc

  /**
   * Returns  a query that  can  be  used to fetch
   * @param  string type                 [description]
   * @param  string id                   [description]
   * @param  function invalidationCallback [description]
   * @return query                      [description]
   */
  generateLiveQuery(type, id, invalidationCallback) {
    let query = {
      queryInstanceId: `${type}:${id}`,
      id: id,
      type: type,
      invalidationCallback: invalidationCallback,
    }
    this._queries.push(query)
    this.socket.subscribeToQuery(type, id)
    return query
  }

  generateStaticQuery(type, id) {
    let query = {
      queryInstanceId: `${type}:${id}`,
      id: id,
      type: type,
    }
    return query
  }

  unsubscribeToQuery(queryInstanceId) {
    remove(this._queries, (query) => query.id === queryInstanceId)
    // send unsubscribeToQuery to server
  }

  /**
   * Gets the query
   * @param  string type   [description]
   * @param  string id     [description]
   * @param  number offset [description]
   * @param  number limit  [description]
   * @return promise
   */
  fetch(query, offset = 0, limit = 100) {
    let type = get(query, "type")
    let id = get(query, "id")

    this.inFlightQueriesCount++

    return this.rpc.execute("FETCH_QUERY", type, id, { offset, limit }).then((response) => {
      forEach(response.included, (datum) => this.store.insertDocument(datum))

      // Return it
      this.inFlightQueriesCount--
      return response
    })
  }

  invalidate(type, id) {
    let queriesToInvalidate = filter(
      this._queries,
      (query) => query.type === type && query.id === id
    )
    forEach(queriesToInvalidate, (query) => {
      if (query.invalidationCallback) query.invalidationCallback()
    })
  }
}
